import { Box, Text } from '@opendoor/bricks-next';
import { TextButton } from 'platform/bricks-next';
import type { TextInputSize } from 'platform/components/AccountPreferences';

interface SectionHeaderProps {
  header: string;
  description?: string;
  updating?: boolean;
  saveButtonId: string;
  onSave: () => void;
  inputSize: TextInputSize;
  analyticsName: string;
}

/**
 * Section header to trigger save action for Each section in Account preferences
 *
 */
export const SectionHeader = ({
  header,
  description,
  onSave,
  saveButtonId,
  analyticsName,
  inputSize,
  updating,
}: SectionHeaderProps) => (
  <Box gap="$6x">
    <Box
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      $largerThanSM={{ alignItems: 'flex-end' }}
    >
      <Text
        tag="h2"
        typography="$subheaderMedium"
        $largerThanSM={{
          typography: '$headerSmall',
        }}
      >
        {header}
      </Text>
      <TextButton
        id={saveButtonId}
        disabled={updating}
        label="Save"
        variant="primary"
        size={inputSize}
        analyticsName={analyticsName}
        onPress={onSave}
      />
    </Box>
    {description && (
      <Text tag="h2" typography="$bodyLarge">
        {description}
      </Text>
    )}
  </Box>
);
